import React, { useState, useEffect, useRef } from 'react';
import { Chart, registerables } from 'chart.js';
import './Analytics.css';

Chart.register(...registerables);

function fmt(n) {
  if (n === null || n === undefined) return '—';
  if (Math.abs(n) >= 1000000) return '€' + (n / 1000000).toFixed(2) + 'M';
  if (Math.abs(n) >= 1000) return '€' + Math.round(Math.abs(n) / 1000) + 'K';
  return '€' + Math.abs(n).toLocaleString('es-ES');
}

const ALL_MONTHS   = ['dic-24','ene-25','feb-25','mar-25','abr-25','may-25','jun-25','jul-25','ago-25','sep-25','oct-25','nov-25','dic-25','ene-26','feb-26'];
const NET_POS_DATA = [-520000,-580000,-595000,-550000,-490000,-545000,-490000,-510000,-1650000,-1730000,-2080000,-2100000,-2850000,-3480000,-3450000];
const PAID_DATA    = [80000,30000,60000,0,0,120000,0,150000,420000,50000,280000,100000,700000,600000,0];
const COLL_DATA    = [15000,25000,45000,30000,60000,55000,40000,90000,220000,100000,150000,80000,0,0,30000];
const TREND_DATA   = [-300000,-620000,-940000,-1260000,-1580000,-1900000,-2220000,-2540000,-2860000,-3180000,-3180000,-3180000,-3180000,-3180000,-3180000];

const CASH_EVENTS = [
  { date: '2026-02-15', proj: 'Xilxes 1 - Burriana',     type: 'arras',  label: '4ª tanda · fase 2',      amount: 40000, status: 'pending' },
  { date: '2026-03-01', proj: 'TR Toledo - Camarena',     type: 'arras',  label: '3ª tanda · bloque B',    amount: 80000, status: 'forecast' },
  { date: '2026-03-15', proj: 'Serra - Core Capital',     type: 'refund', label: 'Refund · firma estimada',amount: 74000, status: 'forecast' },
  { date: '2026-04-01', proj: 'Valencia 22 - Chilches',   type: 'refund', label: 'Refund · 3 clientes',    amount: 18000, status: 'forecast' },
  { date: '2026-05-01', proj: 'Santa Isabel - Almassora', type: 'refund', label: 'Refund · firma estimada',amount: 8000,  status: 'forecast' },
  { date: '2026-06-01', proj: 'Xilxes 1 - Burriana',     type: 'arras',  label: '5ª tanda · fase 3',      amount: 40000, status: 'forecast' },
  { date: '2026-06-15', proj: 'Sepúlveda 63 - Sagunto',  type: 'refund', label: 'Refund · firma estimada',amount: 22000, status: 'forecast' },
  { date: '2026-07-01', proj: 'Av. Murcia 14 - Elche',   type: 'refund', label: 'Refund · firma estimada',amount: 12000, status: 'forecast' },
  { date: '2026-09-01', proj: 'San José - Xirivella',     type: 'arras',  label: 'Tanda estimada cierre',  amount: 20000, status: 'forecast' },
];

const AGING_SETS = {
  current: [
    [null, null, null, null, null, null, null, null, null],
    [null, 274345, 158000, 40000, null, null, null, 472345, 472345],
    [9, 90250, 18498, 168970, null, 104491, null, 382218, 277727],
    [4000, 570350, 28471, 375000, null, null, null, 977821, 977821],
    [144408, -313619, 363593, 155949, -69772, 830962, 247429, 1358951, 528118],
  ],
  '30d': [
    [null, null, null, null, null, null, null, null, null],
    [null, 180000, 120000, 40000, null, null, null, 340000, 340000],
    [9, 70000, 15000, 140000, null, 90000, null, 315009, 225009],
    [3000, 450000, 22000, 280000, null, null, null, 755000, 755000],
    [100000, -200000, 280000, 120000, -50000, 700000, 180000, 1130000, 430000],
  ],
  '90d': [
    [null, null, null, null, null, null, null, null, null],
    [null, 100000, 80000, 20000, null, null, null, 200000, 200000],
    [null, 50000, 10000, 100000, null, 60000, null, 220000, 160000],
    [2000, 300000, 15000, 200000, null, null, null, 517000, 517000],
    [80000, -150000, 200000, 100000, -30000, 500000, 120000, 820000, 320000],
  ],
  eoy: [
    [null, null, null, null, null, null, null, null, null],
    [null, 200000, 110000, 30000, null, null, null, 340000, 340000],
    [5, 60000, 12000, 130000, null, 80000, null, 282005, 202005],
    [2000, 400000, 20000, 290000, null, null, null, 712000, 712000],
    [110000, -250000, 300000, 130000, -60000, 750000, 200000, 1180000, 430000],
  ],
};

const MOCK_PROJECTS_ANALYTICS = [
  { id: 'PROJ-XIL-001', name: 'Xilxes 1 - Burriana',     type: 'PROJECT',      paid: 118000, collected: 79500,  refundPending: 12000, totalUnits: 12, soldUnits: 7,  unassigned: [{ unit: 'V6', address: 'C. Xilxes 1, V6, Burriana', toBeCollected: 8000 }, { unit: 'V7', address: 'C. Xilxes 1, V7, Burriana', toBeCollected: 8000 }, { unit: 'V8', address: 'C. Xilxes 1, V8', toBeCollected: 8000 }, { unit: 'V10', address: 'C. Xilxes 1, V10', toBeCollected: 9500 }, { unit: 'V11', address: 'C. Xilxes 1, V11', toBeCollected: 9500 }] },
  { id: 'PROJ-TOL-002', name: 'TR Toledo - Camarena',     type: 'BUILDING',     paid: 269000, collected: 224000, refundPending: 5300,  totalUnits: 22, soldUnits: 19, unassigned: [{ unit: 'Es:2 Pl:00 Pt:A', address: 'TR Toledo 2, Camarena', toBeCollected: 10000 }, { unit: 'Es:2 Pl:00 Pt:B', address: 'TR Toledo 2, Camarena', toBeCollected: 10000 }, { unit: 'Es:2 Pl:01 Pt:A', address: 'TR Toledo 2, Camarena', toBeCollected: 10000 }] },
  { id: 'PROJ-SER-003', name: 'Serra - Core Capital',     type: 'VP 10%',       paid: 193000, collected: 214000, refundPending: 74000, totalUnits: 13, soldUnits: 13, unassigned: [] },
  { id: 'PROJ-XIR-004', name: 'San José - Xirivella',     type: 'PROJECT',      paid: 55000,  collected: 42500,  refundPending: 0,     totalUnits: 9,  soldUnits: 6,  unassigned: [{ unit: 'V5', address: 'C. San José 1, V5', toBeCollected: 7500 }, { unit: 'V8', address: 'C. San José 1, V8', toBeCollected: 7500 }, { unit: 'V9', address: 'C. San José 1, V9', toBeCollected: 7500 }] },
  { id: 'PROJ-VLC-005', name: 'Valencia 22 - Chilches',   type: 'BUILDING',     paid: 210000, collected: 148000, refundPending: 18000, totalUnits: 10, soldUnits: 6,  unassigned: [{ unit: 'V4', address: 'C. Valencia 22, V4', toBeCollected: 12000 }, { unit: 'V6', address: 'C. Valencia 22, V6', toBeCollected: 12000 }, { unit: 'V8', address: 'C. Valencia 22, V8', toBeCollected: 14000 }, { unit: 'V10', address: 'C. Valencia 22, V10', toBeCollected: 14000 }] },
  { id: 'PROJ-ALM-006', name: 'Santa Isabel - Almassora', type: 'WIP',          paid: 140000, collected: 51000,  refundPending: 8000,  totalUnits: 8,  soldUnits: 3,  unassigned: [{ unit: 'Unidad 2', address: 'C. Santa Isabel 10', toBeCollected: 18000 }, { unit: 'Unidad 3', address: 'C. Santa Isabel 10', toBeCollected: 18000 }, { unit: 'Unidad 4', address: 'C. Santa Isabel 10', toBeCollected: 18000 }, { unit: 'Unidad 5', address: 'C. Santa Isabel 10', toBeCollected: 18000 }, { unit: 'Unidad 6', address: 'C. Santa Isabel 10', toBeCollected: 18000 }] },
  { id: 'PROJ-SAG-007', name: 'Sepúlveda 63 - Sagunto',  type: 'NEW BUILDING', paid: 175000, collected: 70000,  refundPending: 22000, totalUnits: 14, soldUnits: 5,  unassigned: [{ unit: 'A03', address: 'Sepúlveda 63, Puerto de Sagunto', toBeCollected: 15000 }, { unit: 'A04', address: 'Sepúlveda 63', toBeCollected: 15000 }, { unit: 'A05', address: 'Sepúlveda 63', toBeCollected: 15000 }, { unit: 'A06', address: 'Sepúlveda 63', toBeCollected: 15000 }, { unit: 'A07', address: 'Sepúlveda 63', toBeCollected: 15000 }, { unit: 'A08', address: 'Sepúlveda 63', toBeCollected: 15000 }, { unit: 'A09', address: 'Sepúlveda 63', toBeCollected: 15000 }, { unit: 'A10', address: 'Sepúlveda 63', toBeCollected: 15000 }, { unit: 'A11', address: 'Sepúlveda 63', toBeCollected: 15000 }] },
  { id: 'PROJ-MUR-008', name: 'Av. Murcia 14 - Elche',   type: 'WIP',          paid: 120000, collected: 42000,  refundPending: 12000, totalUnits: 6,  soldUnits: 2,  unassigned: [{ unit: 'B02', address: 'Av. Murcia 14, Elche', toBeCollected: 11000 }, { unit: 'B03', address: 'Av. Murcia 14', toBeCollected: 11000 }, { unit: 'B04', address: 'Av. Murcia 14', toBeCollected: 11000 }, { unit: 'B05', address: 'Av. Murcia 14', toBeCollected: 11000 }] },
];

function netPos(p) { return (p.paid || p.arrasPageadas || 0) - (p.collected || 0); }

const AGING_LABELS = [['0 days','7 days'],['8 days','30 days'],['31 days','60 days'],['61 days','90 days'],['91 days','99999 days']];

function Analytics({ projects: airtableProjects }) {
  const allProjects = (airtableProjects && airtableProjects.length > 0)
    ? airtableProjects.map(p => ({ ...p, paid: p.arrasPageadas || p.paid || 0, unassigned: p.unassigned || [] }))
    : MOCK_PROJECTS_ANALYTICS;

  const [period, setPeriod]           = useState('today');
  const [customRange, setCustomRange] = useState({ from: '', to: '' });
  const [searchVal, setSearchVal]     = useState('');
  const [typeFilter, setTypeFilter]   = useState('');
  const [evoRange, setEvoRange]       = useState('all');
  const [barRange, setBarRange]       = useState('12m');
  const [sortKey, setSortKey]         = useState('netpos');
  const [cashTypeFilter, setCashTypeFilter] = useState('all');
  const [cashHorizon, setCashHorizon]       = useState(90);
  const [uaTypeFilter, setUaTypeFilter]     = useState('all');
  const [uaSearch, setUaSearch]             = useState('');
  const [uaExpanded, setUaExpanded]         = useState(new Set([0]));
  const [agingPeriod, setAgingPeriod]       = useState('current');

  const evoRef    = useRef(null);
  const flowRef   = useRef(null);
  const donutRef  = useRef(null);
  const evoChart  = useRef(null);
  const flowChart = useRef(null);
  const donutChart = useRef(null);

  const filteredProjects = allProjects.filter(p => {
    const matchName = !searchVal || p.name.toLowerCase().includes(searchVal.toLowerCase()) || (p.id||'').toLowerCase().includes(searchVal.toLowerCase());
    const matchType = !typeFilter || p.type === typeFilter;
    return matchName && matchType;
  });

  const totals = filteredProjects.reduce((acc, p) => {
    acc.paid      += p.paid || 0;
    acc.collected += p.collected || 0;
    acc.refund    += p.refundPending || 0;
    return acc;
  }, { paid: 0, collected: 0, refund: 0 });

  const nonVP = filteredProjects.filter(p => p.type !== 'VP 10%');
  const netNonVP = nonVP.reduce((s, p) => s + netPos(p), 0);
  const policyLimit = 2600000;
  const policyPct = Math.min((netNonVP / 4000000) * 100, 100);
  const overLimit = netNonVP - policyLimit;

  const months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];

  // Cash events filtered
  const now = new Date('2026-05-13');
  const horizonDate = new Date(now);
  horizonDate.setDate(horizonDate.getDate() + (cashHorizon === 9999 ? 99999 : cashHorizon));
  const cashEvents = CASH_EVENTS.filter(e => {
    const d = new Date(e.date);
    const inHorizon = d >= now && d <= horizonDate;
    const matchType = cashTypeFilter === 'all' || e.type === cashTypeFilter;
    return inHorizon && matchType;
  }).sort((a, b) => new Date(a.date) - new Date(b.date));

  const cashTotal       = cashEvents.reduce((s, e) => s + e.amount, 0);
  const cashArrasTotal  = cashEvents.filter(e => e.type === 'arras').reduce((s, e) => s + e.amount, 0);
  const cashRefundTotal = cashEvents.filter(e => e.type === 'refund').reduce((s, e) => s + e.amount, 0);

  // Unassigned units
  const uaProjects = allProjects.filter(p => {
    const matchType = uaTypeFilter === 'all' || p.type === uaTypeFilter;
    const matchSearch = !uaSearch || p.name.toLowerCase().includes(uaSearch) || (p.unassigned||[]).some(u => u.unit.toLowerCase().includes(uaSearch) || u.address.toLowerCase().includes(uaSearch));
    return matchType && matchSearch && (p.unassigned||[]).length > 0;
  });
  const allUnassigned = uaProjects.flatMap(p => p.unassigned || []);
  const uaPotential = allUnassigned.reduce((s, u) => s + u.toBeCollected, 0);

  // Sort bars data
  let barData = [...filteredProjects.filter(p => p.type !== 'VP 10%')];
  if (sortKey === 'netpos') barData.sort((a, b) => netPos(b) - netPos(a));
  else if (sortKey === 'name') barData.sort((a, b) => a.name.localeCompare(b.name));
  else if (sortKey === 'type') barData.sort((a, b) => a.type.localeCompare(b.type));
  const maxBar = Math.max(...barData.map(p => Math.abs(netPos(p))), 1);

  const periodLabels = { today: 'Hoy · 13 May 2026', '7d': 'Últimos 7 días', mtd: 'Mayo 2026', qtd: 'T2 2026', ytd: 'Ene–May 2026', all: 'Todo el histórico' };

  // Charts
  useEffect(() => {
    if (!evoRef.current) return;
    const n = evoRange === '3m' ? 3 : evoRange === '6m' ? 6 : evoRange === '12m' ? 12 : ALL_MONTHS.length;
    const labels = ALL_MONTHS.slice(-n);
    const values = NET_POS_DATA.slice(-n);
    const trend  = TREND_DATA.slice(-n);
    if (evoChart.current) evoChart.current.destroy();
    evoChart.current = new Chart(evoRef.current, {
      type: 'line',
      data: { labels, datasets: [
        { label: 'Net Position', data: values, borderColor: '#c0392b', backgroundColor: 'rgba(192,57,43,0.07)', borderWidth: 2.5, pointRadius: 4, pointBackgroundColor: '#c0392b', tension: 0.3, fill: true, order: 1 },
        { label: 'Tendencia', data: trend, borderColor: '#aab8d4', borderWidth: 1.5, borderDash: [5, 5], pointRadius: 0, tension: 0, fill: false, order: 2 },
        { label: 'Límite €2.6M', data: labels.map(() => -2600000), borderColor: '#a32d2d', borderWidth: 1.5, borderDash: [8, 4], pointRadius: 0, fill: false, order: 0 },
      ] },
      options: {
        responsive: true, interaction: { mode: 'index', intersect: false },
        plugins: {
          legend: { position: 'bottom', labels: { boxWidth: 12, font: { size: 11 } } },
          tooltip: { callbacks: { label: c => ' ' + c.dataset.label + ': €' + Math.abs(c.parsed.y).toLocaleString('es-ES') } },
        },
        scales: {
          y: { ticks: { callback: v => '(' + (Math.abs(v) / 1000000).toFixed(1) + 'M)', font: { size: 11 } }, grid: { color: 'rgba(0,0,0,0.04)' } },
          x: { ticks: { font: { size: 11 } }, grid: { display: false } },
        },
      },
    });
    return () => { if (evoChart.current) evoChart.current.destroy(); };
  }, [evoRange]);

  useEffect(() => {
    if (!flowRef.current) return;
    const n = barRange === '3m' ? 3 : barRange === '6m' ? 6 : 12;
    const labels = ALL_MONTHS.slice(-n);
    if (flowChart.current) flowChart.current.destroy();
    flowChart.current = new Chart(flowRef.current, {
      type: 'bar',
      data: { labels, datasets: [
        { label: 'Arras pagadas al vendedor', data: PAID_DATA.slice(-n).map(v => -v), backgroundColor: 'rgba(163,45,45,0.7)', borderColor: '#a32d2d', borderWidth: 1, borderRadius: 3 },
        { label: 'Arras cobradas de clientes', data: COLL_DATA.slice(-n), backgroundColor: 'rgba(29,158,117,0.7)', borderColor: '#1D9E75', borderWidth: 1, borderRadius: 3 },
      ] },
      options: {
        responsive: true, interaction: { mode: 'index', intersect: false },
        plugins: {
          legend: { position: 'bottom', labels: { boxWidth: 12, font: { size: 11 } } },
          tooltip: { callbacks: { label: c => ' ' + c.dataset.label + ': €' + Math.abs(c.parsed.y).toLocaleString('es-ES') } },
        },
        scales: {
          y: { ticks: { callback: v => '€' + (Math.abs(v) / 1000).toFixed(0) + 'K', font: { size: 11 } }, grid: { color: 'rgba(0,0,0,0.04)' } },
          x: { ticks: { font: { size: 11 } }, grid: { display: false } },
        },
      },
    });
    return () => { if (flowChart.current) flowChart.current.destroy(); };
  }, [barRange]);

  useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps
    if (!donutRef.current) return;
    const byType = {};
    filteredProjects.forEach(p => {
      const key = p.type;
      byType[key] = (byType[key] || 0) + netPos(p);
    });
    const labels = Object.keys(byType).filter(k => byType[k] > 0);
    const data   = labels.map(k => byType[k]);
    const colors = ['#185fa5', '#2E86C1', '#EF9F27', '#a32d2d', '#8E44AD', '#1D9E75'];
    if (donutChart.current) donutChart.current.destroy();
    donutChart.current = new Chart(donutRef.current, {
      type: 'doughnut',
      data: { labels, datasets: [{ data, backgroundColor: colors.slice(0, labels.length), borderWidth: 2, borderColor: '#fff', hoverBorderWidth: 3 }] },
      options: {
        responsive: true, cutout: '60%',
        plugins: {
          legend: { position: 'bottom', labels: { boxWidth: 12, font: { size: 11 }, padding: 8 } },
          tooltip: { callbacks: { label: c => ' ' + c.label + ': €' + c.parsed.toLocaleString('es-ES') } },
        },
      },
    });
    return () => { if (donutChart.current) donutChart.current.destroy(); };
  }, [filteredProjects, searchVal, typeFilter]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleUA = (idx) => {
    setUaExpanded(prev => {
      const next = new Set(prev);
      next.has(idx) ? next.delete(idx) : next.add(idx);
      return next;
    });
  };

  const renderAgingRow = (row, i) => {
    const isTotal = i === AGING_LABELS.length;
    const totalsRow = ['148.417', '621.326', '568.562', '739.919', '(69.772)', '935.453', '247.429'];
    if (isTotal) {
      return (
        <tr key="total">
          <td><strong>Total</strong></td><td></td>
          {totalsRow.map((v, j) => (
            <td key={j} className={v.startsWith('(') ? 'pos' : 'neg'}><strong>{v}</strong></td>
          ))}
          <td className="total-col neg"><strong>3.191.334</strong></td>
          <td className="excl neg"><strong>2.255.881</strong></td>
        </tr>
      );
    }
    return (
      <tr key={i} style={i % 2 ? { background: 'var(--bg2)' } : {}}>
        <td>{AGING_LABELS[i][0]}</td><td>{AGING_LABELS[i][1]}</td>
        {[0,1,2,3,4,5,6].map(j => {
          const v = row[j];
          if (v === null || v === undefined) return <td key={j}>—</td>;
          const cls = v < 0 ? 'pos' : 'neg';
          const disp = v < 0 ? '(' + Math.abs(v).toLocaleString('es-ES') + ')' : v.toLocaleString('es-ES');
          return <td key={j} className={cls}>{disp}</td>;
        })}
        {row[7] === null || row[7] === undefined
          ? <><td className="total-col">—</td><td className="excl">—</td></>
          : <><td className="total-col neg">{row[7].toLocaleString('es-ES')}</td><td className="excl neg">{(row[8]||row[7]).toLocaleString('es-ES')}</td></>
        }
      </tr>
    );
  };

  return (
    <div className="aw2">

      {/* Period filter bar */}
      <div className="filter-bar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
          <i className="ti ti-calendar-filter" style={{ fontSize: 14, color: 'var(--tx2)' }}></i>
          <span style={{ fontSize: 12, fontWeight: 600 }}>Período</span>
        </div>
        <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
          {[['today','Hoy'],['7d','7 días'],['mtd','Este mes'],['qtd','Este trimestre'],['ytd','Este año'],['all','Todo'],['custom','Personalizado']].map(([k,l]) => (
            <button key={k} className={`tpb${period === k ? ' active' : ''}`} onClick={() => setPeriod(k)}>{l}</button>
          ))}
        </div>
        {period === 'custom' && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input type="date" value={customRange.from} onChange={e => setCustomRange(p => ({ ...p, from: e.target.value }))} style={{ width: 130, fontSize: 12, padding: '5px 8px' }} />
            <span style={{ fontSize: 12, color: 'var(--tx2)' }}>—</span>
            <input type="date" value={customRange.to} onChange={e => setCustomRange(p => ({ ...p, to: e.target.value }))} style={{ width: 130, fontSize: 12, padding: '5px 8px' }} />
          </div>
        )}
        <div style={{ flex: 1 }}></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div className="search-box-sm">
            <i className="ti ti-search" style={{ fontSize: 13 }}></i>
            <input type="text" placeholder="Buscar proyecto..." value={searchVal} onChange={e => setSearchVal(e.target.value)} style={{ width: 180 }} />
          </div>
          <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} style={{ fontSize: 12, padding: '6px 10px', borderRadius: 'var(--r8)', border: '0.5px solid var(--bd2)', background: 'var(--bg)', width: 'auto' }}>
            <option value="">Todos los tipos</option>
            <option>PROJECT</option><option>BUILDING</option><option>WIP</option>
            <option>NEW BUILDING</option><option>VP 10%</option><option>LOT</option>
          </select>
        </div>
        <div style={{ fontSize: 11, color: 'var(--tx2)', whiteSpace: 'nowrap', flexShrink: 0 }}>
          {period === 'custom' && customRange.from && customRange.to
            ? `${customRange.from} — ${customRange.to}`
            : periodLabels[period] || period}
        </div>
      </div>

      {/* Policy bar */}
      <div className="policy-bar">
        <div>
          <div style={{ fontSize: 13, fontWeight: 600 }}>Límite de posición neta</div>
          <div style={{ fontSize: 11, color: 'var(--tx2)', marginTop: 2 }}>Política interna · excluye VP 10%</div>
        </div>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: 'var(--tx2)', marginBottom: 4 }}>
            <span>€0</span><span style={{ color: 'var(--rt)', fontWeight: 600 }}>Límite €2.6M</span><span>€4M</span>
          </div>
          <div className="policy-track">
            <div className="policy-fill" style={{ width: policyPct + '%', background: 'linear-gradient(90deg,#EF9F27,#a32d2d)' }}></div>
            <div className="policy-limit" style={{ left: '65%' }}>
              <div className="policy-limit-label">€2.6M</div>
            </div>
          </div>
        </div>
        <div>
          <div className="policy-value" style={{ color: overLimit > 0 ? 'var(--rt)' : 'var(--gt)' }}>{fmt(netNonVP)}</div>
          <div style={{ fontSize: 10, color: 'var(--tx2)', textAlign: 'right' }}>posición actual excl. VP</div>
        </div>
        <div className="policy-status" style={{ background: overLimit > 0 ? 'var(--rs)' : 'var(--gs)', color: overLimit > 0 ? 'var(--rt)' : 'var(--gt)' }}>
          {overLimit > 0 ? (
            <><i className="ti ti-alert-triangle" style={{ fontSize: 11, marginRight: 4 }}></i>+{fmt(overLimit)} sobre límite</>
          ) : (
            <><i className="ti ti-check" style={{ fontSize: 11, marginRight: 4 }}></i>Dentro del límite</>
          )}
        </div>
      </div>

      {/* KPI Grid */}
      <div className="kpi-grid">
        <div className="kpi">
          <div className="kpi-label"><i className="ti ti-arrow-up-circle" style={{ color: 'var(--rt)' }}></i>Arras pagadas al vendedor</div>
          <div className="kpi-value" style={{ color: 'var(--rt)' }}>{fmt(totals.paid)}</div>
          <div className="kpi-sub">{filteredProjects.length} proyectos activos</div>
          <div className="kpi-icon ti ti-arrow-up-circle"></div>
        </div>
        <div className="kpi">
          <div className="kpi-label"><i className="ti ti-arrow-down-circle" style={{ color: 'var(--gt)' }}></i>Arras collected</div>
          <div className="kpi-value" style={{ color: 'var(--gt)' }}>{fmt(totals.collected)}</div>
          <div className="kpi-sub">to be collected + señal cobrada</div>
          <div className="kpi-icon ti ti-arrow-down-circle"></div>
        </div>
        <div className="kpi">
          <div className="kpi-label"><i className="ti ti-scale" style={{ color: 'var(--rt)' }}></i>Posición neta</div>
          <div className="kpi-value" style={{ color: 'var(--rt)' }}>−{fmt(totals.paid - totals.collected)}</div>
          <div className="kpi-sub">arras pagadas − arras collected</div>
          <div className="kpi-icon ti ti-scale"></div>
        </div>
        <div className="kpi">
          <div className="kpi-label"><i className="ti ti-refresh" style={{ color: 'var(--yt)' }}></i>Arras to be refund pendiente</div>
          <div className="kpi-value" style={{ color: 'var(--yt)' }}>{fmt(totals.refund)}</div>
          <div className="kpi-sub">señal cobrada aún no devuelta</div>
          <div className="kpi-icon ti ti-refresh"></div>
        </div>
      </div>

      {/* Evolution Chart */}
      <div className="chart-card full">
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, marginBottom: 4 }}>
          <div>
            <div className="chart-title"><i className="ti ti-chart-line" style={{ color: 'var(--rt)' }}></i>Evolución Net Position</div>
            <div className="chart-sub">Posición neta mensual · línea discontinua = límite política €2.6M excl. VP</div>
          </div>
          <div style={{ display: 'flex', gap: 5 }}>
            {[['all','Todo'],['12m','12m'],['6m','6m'],['3m','3m']].map(([k,l]) => (
              <button key={k} className={`cc-btn${evoRange === k ? ' active' : ''}`} onClick={() => setEvoRange(k)}>{l}</button>
            ))}
          </div>
        </div>
        <canvas ref={evoRef} height={70}></canvas>
      </div>

      {/* Bars + Donut */}
      <div className="chart-grid">
        <div className="chart-card">
          <div className="chart-title"><i className="ti ti-building" style={{ color: 'var(--it)' }}></i>Net position por proyecto</div>
          <div className="chart-sub">Ranking de exposición. Excluye VP 10%.</div>
          <div className="chart-controls">
            <span style={{ fontSize: 11, color: 'var(--tx2)', marginRight: 4 }}>Ordenar:</span>
            {[['netpos','Mayor exposición'],['name','A-Z'],['type','Tipo']].map(([k,l]) => (
              <button key={k} className={`cc-btn${sortKey === k ? ' active' : ''}`} onClick={() => setSortKey(k)}>{l}</button>
            ))}
          </div>
          <div>
            {barData.map(p => {
              const np = netPos(p);
              const pct = Math.min(Math.abs(np) / maxBar * 100, 100);
              const color = np <= 0 ? '#1D9E75' : np > 80000 ? '#a32d2d' : '#EF9F27';
              const label = np <= 0 ? '+' + fmt(Math.abs(np)) + ' ✓' : '−' + fmt(np) + ' exp.';
              return (
                <div key={p.id} className="bar-row">
                  <div className="bar-label" title={p.name}>{p.name} <span style={{ fontSize: 9, color: 'var(--tx3)' }}>{p.type}</span></div>
                  <div className="bar-track">
                    <div className="bar-fill" style={{ width: pct + '%', background: color }}>
                      <span>{label}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="chart-card">
          <div className="chart-title"><i className="ti ti-chart-donut" style={{ color: 'var(--yt)' }}></i>Composición por tipo de activo</div>
          <div className="chart-sub">Distribución del importe pendiente de recuperar</div>
          <canvas ref={donutRef} height={200}></canvas>
        </div>
      </div>

      {/* Cash flow */}
      <div className="chart-card full">
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, marginBottom: 14 }}>
          <div>
            <div className="chart-title"><i className="ti ti-calendar-event" style={{ color: 'var(--yt)' }}></i>Próximas salidas de caja</div>
            <div className="chart-sub">Tandas de arras pendientes + arras to be refund · ordenadas por fecha</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', gap: 5 }}>
              {[['all','Todo'],['arras','Solo arras'],['refund','Solo refund']].map(([k,l]) => (
                <button key={k} className={`cc-btn${cashTypeFilter === k ? ' active' : ''}`} onClick={() => setCashTypeFilter(k)}>{l}</button>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 5 }}>
              {[[90,'90 días'],[180,'6 meses'],[9999,'Todo']].map(([k,l]) => (
                <button key={k} className={`cc-btn${cashHorizon === k ? ' active' : ''}`} onClick={() => setCashHorizon(k)}>{l}</button>
              ))}
            </div>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0,1fr))', gap: 10, marginBottom: 16 }}>
          <div style={{ background: 'var(--bg3)', borderRadius: 'var(--r8)', padding: '10px 14px' }}>
            <div style={{ fontSize: 11, color: 'var(--tx2)', marginBottom: 3 }}>Total salidas previstas</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--rt)' }}>−{fmt(cashTotal)}</div>
            <div style={{ fontSize: 10, color: 'var(--tx3)' }}>{cashHorizon === 90 ? 'próximos 90 días' : cashHorizon === 180 ? 'próximos 6 meses' : 'total previsto'}</div>
          </div>
          <div style={{ background: 'var(--bg3)', borderRadius: 'var(--r8)', padding: '10px 14px' }}>
            <div style={{ fontSize: 11, color: 'var(--tx2)', marginBottom: 3 }}>Tandas de arras pendientes</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--rt)' }}>{cashArrasTotal ? '−' + fmt(cashArrasTotal) : '€0'}</div>
            <div style={{ fontSize: 10, color: 'var(--tx3)' }}>pagos al vendedor</div>
          </div>
          <div style={{ background: 'var(--bg3)', borderRadius: 'var(--r8)', padding: '10px 14px' }}>
            <div style={{ fontSize: 11, color: 'var(--tx2)', marginBottom: 3 }}>Arras to be refund</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--yt)' }}>{cashRefundTotal ? '−' + fmt(cashRefundTotal) : '€0'}</div>
            <div style={{ fontSize: 10, color: 'var(--tx3)' }}>señal a devolver a clientes</div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 320, overflowY: 'auto' }}>
          {cashEvents.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 20, fontSize: 12, color: 'var(--tx3)' }}>No hay salidas previstas en este período</div>
          ) : cashEvents.map((e, i) => {
            const d = new Date(e.date);
            const ds = d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
            const isArras = e.type === 'arras';
            const borderColor = e.status === 'pending' ? 'var(--yt)' : 'var(--bd2)';
            return (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '9px 12px', borderRadius: 'var(--r8)', background: 'var(--bg2)', border: '0.5px solid var(--bd)', borderLeft: `3px solid ${borderColor}` }}>
                <div style={{ fontSize: 11, fontWeight: 600, minWidth: 90, color: 'var(--tx2)' }}>{ds}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{e.proj}</div>
                  <div style={{ fontSize: 10, color: 'var(--tx2)', marginTop: 1 }}>{e.label}</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                  <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: isArras ? 'var(--rs)' : 'var(--ys)', color: isArras ? 'var(--rt)' : 'var(--yt)' }}>
                    {isArras ? 'Tanda arras' : 'To be refund'}
                  </span>
                  <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: e.status === 'pending' ? 'var(--ys)' : 'var(--bg2)', color: e.status === 'pending' ? 'var(--yt)' : 'var(--tx2)' }}>
                    {e.status === 'pending' ? 'Pendiente' : 'Prevista'}
                  </span>
                  <div style={{ fontSize: 14, fontWeight: 600, color: isArras ? 'var(--rt)' : 'var(--yt)', minWidth: 60, textAlign: 'right' }}>−{fmt(e.amount)}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Flow chart */}
      <div className="chart-card full">
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, marginBottom: 4 }}>
          <div>
            <div className="chart-title"><i className="ti ti-chart-bar" style={{ color: 'var(--it)' }}></i>Flujo mensual: arras pagadas vs cobradas</div>
            <div className="chart-sub">Lo que sale (pagos al vendedor) vs lo que entra (cobros de clientes) · por mes</div>
          </div>
          <div style={{ display: 'flex', gap: 5 }}>
            {[['12m','12m'],['6m','6m'],['3m','3m']].map(([k,l]) => (
              <button key={k} className={`cc-btn${barRange === k ? ' active' : ''}`} onClick={() => setBarRange(k)}>{l}</button>
            ))}
          </div>
        </div>
        <canvas ref={flowRef} height={65}></canvas>
      </div>

      {/* Unassigned units */}
      <div className="chart-card full">
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, marginBottom: 14 }}>
          <div>
            <div className="chart-title"><i className="ti ti-home-off" style={{ color: 'var(--rt)' }}></i>Propiedades sin asignar</div>
            <div className="chart-sub">Unidades pendientes de vender por proyecto · sin cliente asignado en Vistral</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', gap: 5 }}>
              {[['all','Todos'],['PROJECT','Project'],['BUILDING','Building'],['WIP','WIP'],['NEW BUILDING','New Building']].map(([k,l]) => (
                <button key={k} className={`cc-btn${uaTypeFilter === k ? ' active' : ''}`} onClick={() => setUaTypeFilter(k)}>{l}</button>
              ))}
            </div>
            <div className="search-box-sm">
              <i className="ti ti-search" style={{ fontSize: 13 }}></i>
              <input type="text" placeholder="Buscar proyecto o unidad..." value={uaSearch} onChange={e => setUaSearch(e.target.value.toLowerCase())} style={{ width: 180 }} />
            </div>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0,1fr))', gap: 10, marginBottom: 16 }}>
          <div style={{ background: 'var(--rs)', borderRadius: 'var(--r8)', padding: '10px 14px' }}>
            <div style={{ fontSize: 11, color: 'var(--rt)', marginBottom: 3 }}>Unidades sin asignar</div>
            <div style={{ fontSize: 22, fontWeight: 600, color: 'var(--rt)' }}>{allUnassigned.length}</div>
            <div style={{ fontSize: 10, color: 'var(--rt)', opacity: 0.7 }}>pendientes de vender</div>
          </div>
          <div style={{ background: 'var(--bg3)', borderRadius: 'var(--r8)', padding: '10px 14px' }}>
            <div style={{ fontSize: 11, color: 'var(--tx2)', marginBottom: 3 }}>Proyectos afectados</div>
            <div style={{ fontSize: 22, fontWeight: 600 }}>{uaProjects.length}</div>
            <div style={{ fontSize: 10, color: 'var(--tx3)' }}>con unidades pendientes</div>
          </div>
          <div style={{ background: 'var(--bg3)', borderRadius: 'var(--r8)', padding: '10px 14px' }}>
            <div style={{ fontSize: 11, color: 'var(--tx2)', marginBottom: 3 }}>To be collected potencial</div>
            <div style={{ fontSize: 22, fontWeight: 600, color: 'var(--it)' }}>{fmt(uaPotential)}</div>
            <div style={{ fontSize: 10, color: 'var(--tx3)' }}>si se venden todas las unidades</div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {uaProjects.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 24, fontSize: 12, color: 'var(--tx3)' }}>No hay unidades sin asignar con estos filtros</div>
          ) : uaProjects.map((p, pi) => {
            const pct = Math.round((p.soldUnits / p.totalUnits) * 100);
            const exp = uaExpanded.has(pi);
            const filteredUnits = (p.unassigned || []).filter(u => !uaSearch || u.unit.toLowerCase().includes(uaSearch) || u.address.toLowerCase().includes(uaSearch));
            const potencial = (p.unassigned || []).reduce((s, u) => s + u.toBeCollected, 0);
            return (
              <div key={p.id} style={{ background: 'var(--bg)', border: '0.5px solid var(--bd)', borderRadius: 'var(--r8)', overflow: 'hidden' }}>
                <div
                  onClick={() => toggleUA(pi)}
                  style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '10px 14px', cursor: 'pointer', background: 'var(--bg2)' }}
                  onMouseOver={e => e.currentTarget.style.background = '#ebe9e3'}
                  onMouseOut={e => e.currentTarget.style.background = 'var(--bg2)'}
                >
                  <span style={{ fontSize: 13, transition: 'transform 0.2s', display: 'inline-block', transform: exp ? 'rotate(90deg)' : 'rotate(0)' }}>›</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontSize: 13, fontWeight: 500 }}>{p.name}</span>
                      <span style={{ fontSize: 10, padding: '2px 6px', borderRadius: 4, background: 'var(--bg3)', color: 'var(--tx2)', border: '0.5px solid var(--bd)' }}>{p.type}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 4 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1, maxWidth: 200 }}>
                        <div style={{ flex: 1, height: 6, background: 'var(--bg3)', borderRadius: 4, overflow: 'hidden' }}>
                          <div style={{ width: pct + '%', height: '100%', background: '#1D9E75', borderRadius: 4 }}></div>
                        </div>
                        <span style={{ fontSize: 11, color: 'var(--tx2)', whiteSpace: 'nowrap' }}>{p.soldUnits}/{p.totalUnits} vendidas</span>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0 }}>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 11, color: 'var(--tx2)' }}>Sin asignar</div>
                      <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--rt)' }}>{(p.unassigned||[]).length} unidades</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 11, color: 'var(--tx2)' }}>Potencial</div>
                      <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--it)' }}>{fmt(potencial)}</div>
                    </div>
                  </div>
                </div>
                {exp && (
                  <div style={{ padding: '4px 0', borderTop: '0.5px solid var(--bd)' }}>
                    {filteredUnits.map((u, ui) => (
                      <div key={ui} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '7px 12px', borderBottom: '0.5px solid var(--bd)', fontSize: 12 }}>
                        <span className="dot dr" style={{ flexShrink: 0 }}></span>
                        <span style={{ fontWeight: 500, minWidth: 80 }}>{u.unit}</span>
                        <span style={{ color: 'var(--tx2)', flex: 1, fontSize: 11 }}>{u.address}</span>
                        <span style={{ fontSize: 11, color: 'var(--it)', fontWeight: 500 }}>To be collected: {fmt(u.toBeCollected)}</span>
                        <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: 'var(--rs)', color: 'var(--rt)' }}>Sin cliente</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div style={{ display: 'flex', gap: 16, marginTop: 12, flexWrap: 'wrap' }}>
          <div style={{ fontSize: 11, color: 'var(--tx2)' }}><span style={{ display: 'inline-block', width: 10, height: 10, background: 'var(--rs)', borderRadius: 2, marginRight: 4, verticalAlign: -1 }}></span>Rojo = exposición activa (pendiente de recuperar)</div>
          <div style={{ fontSize: 11, color: 'var(--tx2)' }}><span style={{ display: 'inline-block', width: 10, height: 10, background: 'var(--gs)', borderRadius: 2, marginRight: 4, verticalAlign: -1 }}></span>Verde = ya recuperado</div>
          <div style={{ fontSize: 11, color: 'var(--tx2)', fontStyle: 'italic' }}>Excl. VP = excluyendo VP 10% · métrica de política de empresa</div>
        </div>
      </div>

      {/* Aging Table */}
      <div className="chart-card full" style={{ marginBottom: 0 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, marginBottom: 12 }}>
          <div>
            <div className="chart-title"><i className="ti ti-table-column" style={{ color: 'var(--tx2)' }}></i>Net position por antigüedad y tipo de activo</div>
            <div className="chart-sub">Posición neta (€) por tramos de días desde el primer pago de arras</div>
          </div>
          <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
            {[['current','Actual'],['30d','Hace 30 días'],['90d','Hace 90 días'],['eoy','Fin 2025']].map(([k,l]) => (
              <button key={k} className={`cc-btn${agingPeriod === k ? ' active' : ''}`} onClick={() => setAgingPeriod(k)}>{l}</button>
            ))}
          </div>
        </div>
        <div className="aging-wrap">
          <table className="aging-table">
            <thead>
              <tr>
                <th>From</th><th>To</th>
                <th>Unit</th><th>Building</th><th>Project</th><th>WIP</th><th>New Building</th><th>VP 10%</th><th>Lot</th>
                <th className="total-col">Total</th>
                <th style={{ fontStyle: 'italic', fontWeight: 400, color: 'var(--tx2)' }}>Excl. VP</th>
              </tr>
            </thead>
            <tbody>
              {(AGING_SETS[agingPeriod] || []).map((row, i) => renderAgingRow(row, i))}
              {renderAgingRow(null, AGING_LABELS.length)}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
}

export default Analytics;
